import axios from 'axios';
import { getToken } from './tool';

const analyticsAxios = axios.create({
  baseURL: process.env.VUE_APP_APIROOT,
  headers: {
    'X-Fanyun-api-version': process.env.VUE_APP_VERSION || '1.0',
    'Content-Type': 'application/json'
  }
});

const EVENT_CODE = {
  PAGE_PERSONAL_CENTER: 1,
  PAGE_OPEN_SERVICE_WINDOW: 3,
  PAGE_MESSAGE_NOTIFICATION: 4,
  HOME_PAGE_VIEW: 6,
  EMPLOYEE_INFO_VIEW: 7,
  EMPLOYEE_CONTRACT_VIEW: 9,
  SOCIAL_SECURITY_VIEW: 11,
  SALARY_BATCH_VIEW: 13,
  SALARY_BATCH_DETAIL_VIEW: 14,
  SALARY_BATCH_DETAIL_LIST_VIEW: 15,
  SALARY_BATCH_DETAIL_TYPE_SWITCH: 16,
  SALARY_BATCH_DETAIL_DETAIL_VIEW: 17,
  EMPLOYMENT_DATA_VIEW: 19,
  EMPLOYMENT_DATA_DOWNLOAD: 21,
  SOCIAL_SECURITY_DATA_VIEW: 22,
  SOCIAL_SECURITY_DATA_CITY_SWITCH: 23,
  SALARY_DATA_VIEW: 24,
  POLICY_NOTICE_VIEW: 25,
  MESSAGE_NOTIFICATION_VIEW: 27,
  MESSAGE_NOTIFICATION_DETAIL: 28
};

export function trackEvent(eventCode, metadata = null) {
  try {
    const version = process.env.VUE_APP_VERSION || '1.0';
    const payload = {
      version: 'v' + version,
      eventCode: eventCode,
      metadata: typeof metadata === 'object' ? JSON.stringify(metadata) : metadata
    };
    
    analyticsAxios.post(`/api/v${version}/analytics/event`, payload, {
      headers: {
        'Authorization': 'Bearer ' + getToken()
      }
    }).then(res => {
      console.log('Analytics event tracked successfully:', res.status);
    }).catch(err => {
      console.error('Analytics tracking failed:', err);
    });
  } catch (error) {
    console.error('Analytics tracking error:', error);
  }
}

export { EVENT_CODE };
